/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleUTMFromJSON, ApiSimpleUTMToJSON, } from './ApiSimpleUTM';
export function ApiListUTMsResponseFromJSON(json) {
    return ApiListUTMsResponseFromJSONTyped(json, false);
}
export function ApiListUTMsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'utms': !exists(json, 'utms') ? undefined : (json['utms'].map(ApiSimpleUTMFromJSON)),
    };
}
export function ApiListUTMsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'utms': value.utms === undefined ? undefined : (value.utms.map(ApiSimpleUTMToJSON)),
    };
}
